import {UseFloatingReturn} from '@floating-ui/react'
import {createContext, useContext} from 'react'

export type DialogContextType = UseFloatingReturn

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DialogContext = createContext<DialogContextType | null>(null)

export const useDialogContext = () => {
    const context = useContext(DialogContext)

    if(context == null) {
        throw new Error('Dialog components must be wrapped in <Dialog.Root />')
    }

    return context
}

